import CookieHelper from "./CookieHelper.js";

export default class UtmHelper {
    #consentCookieName = "user_performance_cookie_consent";
    #consentGrantedEvent = "on_user_performance_cookie_consent_granted";
    #consentRevokedEvent = "on_user_performance_cookie_consent_withdrawn";

    #utmCookieName = "mc_utm_params";

    constructor() {
        this.updateUtmParameters();

        document.addEventListener(this.#consentGrantedEvent, this.updateUtmParameters);
        document.addEventListener(this.#consentRevokedEvent, this.#deleteStoredValue);
    }

    // Fetch the UTM parameters from the URL and update storage if any exist
    updateUtmParameters = () => {
        let utmParams = this.#getUtmParametersFromUrl();
        if (utmParams.utm_source || utmParams.utm_medium || utmParams.utm_campaign || utmParams.utm_campaign || utmParams.utm_id || utmParams.utm_term || utmParams.utm_content) {
            this.#setStoredValue(utmParams);
        }
    }

    // Retrieve UTM parameters from the URL or storage
    getUtmParameters = () => {        
        let res = this.#getUtmParametersFromUrl();
        if (!res.utm_source && !res.utm_medium && !res.utm_campaign && !res.utm_campaign && !res.utm_id && !res.utm_term && !res.utm_content) {
            let storedValues = this.#getStoredValue();
            if (storedValues) {
                res.utm_source = storedValues.utm_source;
                res.utm_medium = storedValues.utm_medium;
                res.utm_campaign = storedValues.utm_campaign;
                res.utm_id = storedValues.utm_id;
                res.utm_term = storedValues.utm_term;
                res.utm_content = storedValues.utm_content;
            }
        }

        return res;
    }

    // Save the UTM parameters to storage
    #setStoredValue = (val) => {
        if (val) {
            let consentGranted = (CookieHelper.getCookie(this.#consentCookieName) == "1");
            if (consentGranted) {
                CookieHelper.setCookie(this.#utmCookieName, JSON.stringify(val), 1);
            }
        }
    }

    // Delete the UTM paramaters from storage
    #deleteStoredValue = () => {
        CookieHelper.deleteCookie(this.#utmCookieName);
    }

    // Retrieve the UTM parameters from storage
    #getStoredValue = () => {
        let cookieValue = CookieHelper.getCookie(this.#utmCookieName);
        if (cookieValue) {
            return JSON.parse(cookieValue);
        }
        return null;
    }

    // Retrieve the UTM parameters from the URL
    #getUtmParametersFromUrl = () => {        
        let getParams = (new URL(document.location)).searchParams;
        return {
            utm_source: getParams.get('utm_source'),
            utm_medium: getParams.get('utm_medium'),
            utm_campaign: getParams.get('utm_campaign'),
            utm_id: getParams.get('utm_id'),
            utm_term: getParams.get('utm_term'),
            utm_content: getParams.get('utm_content')
        };
    }

}